<mat-card>
  <mat-card-header>
    <mat-card-title>{{'enterprise-certificate_management.screen_name' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise-certificate_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Search form -->
        <form>
          <div class="row">
            <!-- Phương thức ký -->
            <div class="col-lg-3">
              <mat-form-field class="w-100">
                <mat-label>
                  {{'enterprise-certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}}
                </mat-label>
                <mat-select #typeCertificateSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, typeCertificateSelect)" id="focusSelect"
                  name="typeCertificate" [(ngModel)]="digitalCertificate.typeCertificate"
                  (ngModelChange)="onFilterData()">
                  <mat-option value="null" selected
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_all' | translate}}</mat-option>
                  <mat-option value="2" (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_card_CA' | translate}}</mat-option>
                  <mat-option value="1" (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_usb_token' | translate}}</mat-option>
                  <mat-option *ngIf="isHsmPermission" value="0"
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server' | translate}}
                  </mat-option>
                  <mat-option value="3" *ngIf="userType == 5"
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_OTP' | translate}}</mat-option>
                  <mat-option [value]="certificateType.CLOUD_CA"
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' | translate}}
                  </mat-option>
                  <mat-option [value]="certificateType.EASY_CA" *ngIf="isEasyCAPermission"
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_EASY_CA' | translate}}
                  </mat-option>
                  <mat-option [value]="certificateType.VNEID" *ngIf="isVNeIDPermission"
                    (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_vneid' | translate}}
                  </mat-option>
                  <!-- Tạm ẩn chức năng thêm chứng thư số HSM -->
                  <!-- <mat-option value="4" (click)="this.commonService.closeDropdownList(this.typeCertificateSelect)">
                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_HSM' | translate}}</mat-option> -->
                </mat-select>
              </mat-form-field>
            </div>
              <!-- tim kiem theo teen chur theer/ so giay to so de thoai -->
            <div class="col-lg-6">
              <mat-form-field class="w-100">

                <input
                    #focusInput matInput type="text"
                    [placeholder]="'enterprise_customer_management.lbl_taxCodeOrCertificateNo2' | translate"
                    name="taxCodeOrCertificateNo" [(ngModel)]="taxCodeOrCertificateNo" autocomplete="off" />
                <button mat-button *ngIf="taxCodeOrCertificateNo" type="button" matSuffix
                    mat-icon-button aria-label="Clear" (click)="taxCodeOrCertificateNo=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            </div>
            <div class="col-lg-3 d-flex align-items-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onFilterData()"
                [disabled]="isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise-certificate_management.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>

      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">

        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
          <span>{{'enterprise-certificate_management.list_certificate' | translate}} ({{paginate.totalRow}})</span>
          <button style="position: absolute; right: 150px" class="pull-right" mat-stroked-button color="primary" type="button"
            *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM) && isBuyTwoService && isDefaultAdmin"
          (click)="openDialogSync()" >
            <mat-icon class="mr-0">refresh</mat-icon>
            {{'button.synchronized' | translate}}
            {{'notify.from' | translate}}
            <span *ngIf="!isNotAttestedUser">sContract</span>
            <span *ngIf="isNotAttestedUser">vContract</span>
          </button>
          <button class="pull-right" (click)="openDialogAdd()" mat-stroked-button color="primary">
            <mat-icon class="mr-0">add_circle</mat-icon>
            {{'enterprise-certificate_management.buttons.add' | translate}}
          </button>
        </mat-panel-title>

        <!-- Start table -->
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="reponsive-table">

            <!-- Số thứ tự -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Phương thức ký -->
            <ng-container matColumnDef="typeCertificate">
              <mat-header-cell *matHeaderCellDef mat-sort-header  style="min-width: 150px;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.digital_certificate_type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center mat-cell-non-boder-right-bottom"  style="min-width: 150px;">
                <div *ngIf="element.typeCertificate == 0" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 1" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_usb_token' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 2" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_card_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 3" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_OTP' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 4" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_HSM' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == certificateType.CLOUD_CA" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == certificateType.EASY_CA" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_EASY_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == certificateType.VNEID" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_vneid' | translate}}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 150px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Nhà cung cấp -->
            <ng-container matColumnDef="cloudCaProviderName">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'digital_certificate_management.lbl_provider_cloudca' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-left mat-cell-non-boder-right-bottom"  matTooltip="{{element.cloudCaProviderName}}">
                  {{element.cloudCaProviderName}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Chủ thể -->
            <ng-container matColumnDef="issuedTo">
              <mat-header-cell *matHeaderCellDef style="min-width: 200px;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.subject_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom word-break-line" style="min-width: 200px;"
                matTooltip="{{element.issuedTo}}">
                {{element.issuedTo}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 200px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Serial number -->
            <ng-container matColumnDef="serialNumber">
              <mat-header-cell *matHeaderCellDef
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom word-break-line"
                matTooltip="{{element.serialNumber}}">
                {{element.serialNumber}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mã số thuế -->
            <ng-container matColumnDef="taxCode">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.tax_code_cmtnd' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                matTooltip="{{element.taxCode}}">
                {{element.taxCode}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-right">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- Tai khoan ky so tu xa -->
            <ng-container matColumnDef="cloudCaUsername">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.cloudCaUsername' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.cloudCaUsername}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- Số điện thoại -->
            <ng-container matColumnDef="phoneNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.phone_number' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.phoneNumber}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Thời gian hiệu lực hiệu lực -->
            <ng-container matColumnDef="activeDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.effective_time' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        [matTooltip]="(element.activeDate | dateformat) + ' - ' + (element.expireDate | dateformat)"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.activeDate | dateformat}} - {{element.expireDate | dateformat}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Ngày hết hạn -->
            <!-- <ng-container matColumnDef="expireDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-cell-center">
                {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="number-cell-center word-break-line">
                {{element.expireDate | dateformat}}
              </mat-cell>
            </ng-container> -->

            <!-- Trạng thái -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%;"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom word-break-line">
                <div matTooltip="{{'enterprise-certificate_management.tooltips.active' | translate}}"
                  *ngIf="element.certificateStatus == 0 && element.isDeleted === false" class="w-100 text-center"
                  style="color: #09847b">
                  {{'enterprise-certificate_management.certificate_status.active' | translate}}
                </div>
                <div matTooltip="{{'enterprise-certificate_management.tooltips.icon_status_inactive' | translate}}"
                  *ngIf="element.isDeleted === true && element.certificateStatus !== 6" class="w-100 text-center" style="color: #da190b">
                  {{'enterprise-certificate_management.certificate_status.inactive' | translate}}
                </div>
                <div matTooltip="{{'enterprise-certificate_management.tooltips.pending' | translate}}"
                  *ngIf="element.certificateStatus == 1 && element.isDeleted === false" class="w-100 text-center" style="color: #da190b">
                  {{'enterprise-certificate_management.certificate_status.pending' | translate}}
                </div>
                <div matTooltip="{{'enterprise-certificate_management.tooltips.expired' | translate}}"
                  *ngIf="element.certificateStatus == 2 && element.isDeleted === false" class="w-100 text-center">
                  {{'enterprise-certificate_management.certificate_status.expired' | translate}}
                </div>
                <div matTooltip="{{'enterprise-certificate_management.tooltips.revoked' | translate}}"
                  *ngIf="element.certificateStatus == 5 && element.isDeleted === false" class="w-100 text-center">
                  {{'enterprise-certificate_management.certificate_status.revoked' | translate}}
                </div>
                <div matTooltip="{{'enterprise-certificate_management.certificate_status.locked' | translate}}"
                *ngIf="element.certificateStatus == 6" class="w-100 text-center text-primary">
                {{'enterprise-certificate_management.certificate_status.locked' | translate}}
              </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tự động đồng bộ -->
            <ng-container matColumnDef="isSync">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'digital_certificate_management.auto_sync' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div *ngIf="element.isSync == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                  {{ 'button.yes_sign_method_default' | translate }}
                </div>
                <div *ngIf="element.isSync != true && element.typeCertificate == 10" [matTooltip]="'button.no' | translate" style="color: #da190b">
                  {{ 'button.no' | translate }}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%; width: 10%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Lưu phiên ký -->
            <ng-container matColumnDef="hasTransSaved">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.save_session_sign' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div *ngIf="element.hasTransSaved == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                  {{ 'button.yes_sign_method_default' | translate }}
                </div>
                <div *ngIf="element.hasTransSaved == false" [matTooltip]="'button.no' | translate" style="color: #da190b">
                  {{ 'button.no' | translate }}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%; width: 10%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol mat-cell-non-boder-bottom">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"
                style="min-width: 180px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"
                (click)="$event.stopPropagation()" style="min-width: 180px;">
                <!--  edit  -->
                <button mat-icon-button
                  (click)="editDigitalCertificate(element.id, element.idDetail, element.typeCertificate, false)">
                  <mat-icon matTooltip="{{'enterprise-certificate_management.table_headers.edit' | translate}}">
                    supervisor_account
                  </mat-icon>
                </button>
                <!--  view detail  -->
                <button mat-icon-button
                  (click)="viewDigitalCertificateDetail(element.id, element.idDetail, element.typeCertificate)">
                  <mat-icon matTooltip="{{'enterprise-certificate_management.table_headers.view_detail' | translate}}">
                    visibility
                  </mat-icon>
                </button>
                <!-- Thay đổi trạng thái -->
                <button [disabled]="element.certificateStatus == 6" mat-icon-button
                  (click)="onChangeigitalCertificateStatus(element.idDetail, element.certificateStatus === 0)">
                  <mat-icon matTooltipClass="matTooltipBreakLine"
                    matTooltip="{{'enterprise_group_user_management.buttons.unlocked' | translate}}"
                    *ngIf="element.isDeleted == false && element.certificateStatus != 6">lock_open
                  </mat-icon>
                  <mat-icon matTooltipClass="matTooltipBreakLine"
                    matTooltip="{{'enterprise_group_user_management.buttons.locked' | translate}}"
                    *ngIf="element.isDeleted == true || element.certificateStatus == 6">lock
                  </mat-icon>
                </button>
                <button mat-icon-button
                *ngIf="element.typeCertificate === certificateType.CLOUD_CA && element.certificateStatus == 0"
                  (click)="syncDigitalCertificate(element.id, element.idDetail, element.typeCertificate)">
                  <mat-icon matTooltipClass="matTooltipBreakLine"
                    matTooltip="{{'certificate.sync_tooltip' | translate}}"
                   >refresh
                  </mat-icon>
                </button>
                <button mat-icon-button style="cursor: auto;"
                *ngIf="element.typeCertificate !== certificateType.CLOUD_CA">
                  <span> </span>
                </button>
                <button mat-icon-button style="cursor: auto;"
                *ngIf="element.typeCertificate !== certificateType.CLOUD_CA">
                  <span> </span>
                </button>
                <button mat-icon-button matTooltip="{{'headertable.auto_sync_mysign' | translate}}" [ngStyle]="{ color: element.isSync ? '#07736C' :'gray'}"
                  *ngIf="element.typeCertificate === certificateType.CLOUD_CA"
                  (click)="autoSyncMysign(element)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                  </svg>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="min-width: 180px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
            </mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"
            class="table-skeleton-row"
            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>
        <!-- End table -->

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>


  </mat-card-content>
</mat-card>
